import React, { useState, useEffect, useRef } from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from './Tabs'
import { Button } from './Button'
import { Card, CardContent } from './Card'
import { DocumentDuplicateIcon, PencilIcon } from '@heroicons/react/24/solid'
import { Textarea } from '../../components/Task/Textarea'
import { Badge } from './Badge'
import axios from '../../axios/AxiosInstance'
import { EyeIcon } from '@heroicons/react/24/solid'
import { Document, Page } from 'react-pdf'
import logo2 from '../../assets/img/logonv.png'
import { formatJsDate } from '../utils/formatageDate'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/Task/Select'
import { Label } from '../../components/Task/Label'
import { Input } from '../../components/Task/Input'
import { CheckBox } from '../../components/Task/Checkbox'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogDescription,
  DialogTitle,
  DialogFooter,
} from '../../components/Task/Dialog'
import {
  TableHead,
  TableRow,
  Table,
  TableHeader,
  TableBody,
  TableCell,
} from '../../components/Planning/Table'
import { Calendar } from '../../components/Task/Calendar'
import {
  Mail,
  Phone,
  FileText,
  Briefcase,
  CalendarDays,
  UserCircle,
  Euro,
} from 'lucide-react'
import {
  Avatar,
  AvatarImage,
  AvatarFallback,
} from '../../components/Planning/Avatar'
import { message } from 'antd'

const Annonces = () => {
  const [activeTab, setActiveTab] = useState('actives')
  const [annonces, setAnnonces] = useState([])
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isCandidateModalOpen, setIsCandidateModalOpen] = useState(false)
  const [filteredAnnonces, setFilteredAnnonces] = useState([])
  const [cvData, setCvData] = useState('')
  const [isModalCV, setIsModalCV] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [numPages, setNumPages] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [filtrerStatut, setFiltrerStatut] = useState('')
  const [filteredAnnonceByStatus, setFilteredAnnonceByStatus] = useState('')
  const [showClientDropdown, setShowClientDropdown] = useState(false)

  const clientRef = useRef(null)


  const [statutOptions, setStatutOptions] = useState([
    'Présélection',
    'Nouveau',
    'En attente',
    'Sélectionné',
    'Entretien tel',
    'RDV Agence',
    'Proposés Client',
    'RDV avec Client',
    'Recruté',
    'Refusé',
  ])
  const [statutColors, setStatutColors] = useState({
    Présélection: 'bg-gray-100 text-gray-700',
    Nouveau: 'bg-purple-100 text-purple-700',
    Sélectionné: 'bg-yellow-100 text-yellow-700',
    'En attente': 'bg-orange-100 text-orange-700',
    Recruté: 'bg-green-100 text-green-700',
    Refusé: 'bg-red-100 text-red-700',
    'RDV Agence': 'bg-pink-100 text-pink-700',
    'Proposés Client': 'bg-blue-100 text-blue-700',
    'RDV avec Client': 'bg-orange-100 text-orange-700',
    'Entretien tel': 'bg-green-100 text-green-700',
  })

  const [searchTerm, setSearchTerm] = useState('')
  const [searchLocation, setSearchLocation] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(5)
  const [activeFilterTab, setActiveFilterTab] = useState('Tous')
  const [candidatsFiltres, setCandidatsFiltres] = useState([])
  const [status, setStatus] = useState('Tous')
  const [showCandidats, setShowCandidats] = useState('')
  const [candidates, setCandidates] = useState([])
  const [selectedAnnonce, setSelectedAnnonce] = useState(null)
  const [clientSearch, setClientSearch] = useState('')
  const [isLoadingClient, setIsLoadingClient] = useState(false)
  const [timer, setTimer] = useState(null)
  const [clients, setClients] = useState([])
  const [selectedClient, setSelectedClient] = useState([])
  const [clientContacts, setClientContacts] = useState([])

  const searchClient = (word) => {
    console.log(word)

    setClientSearch(word)
    if (word.length === 0) {
      setClients([])
    }
    if (word.length < 3) {
      if (timer) clearTimeout(timer)
    }
    if (word.length >= 3) {
      if (timer) clearTimeout(timer)

      const timer2 = setTimeout(() => {
        setIsLoadingClient(true)
        axios
          .post('client/find-by-text', { query: word })
          .then((res) => {
            setClients(res.data)

            setShowClientDropdown(true)
            console.log(res.data)
          })
          .catch((e) => console.log(e))
          .finally(() => setIsLoadingClient(false))
      }, 700)
      setTimer(timer2)
    }
  }

  const loadAnnonces = () => {
    axios
      .get('annonces')
      .then((res) => {
        const updatedAnnonces = res.data.map((annonce) => {
          console.log(annonce.candidats)
          const updatedCandidats = annonce.candidats.map((candidat) => ({
            ...candidat.candidateId,
            status: candidat.status || 'Nouveau',
            date: candidat.date,
          }))
          console.log(updatedCandidats)
          return { ...annonce, candidats: updatedCandidats }
        })

        setAnnonces(updatedAnnonces)
        setFilteredAnnonces(updatedAnnonces)
      })
      .catch((err) => {
        console.error('Erreur de chargement des annonces', err)
      })
  }

  const loadCandidats = (annonceId) => {
    axios
      .get(`annonces/candidats/${annonceId}`)
      .then((res) => {
        console.log(res)
        if (res.data.length) {
          // Ajouter un statut par défaut "Nouveau" si un candidat n'a pas de statut
          const updatedCandidates = res.data.map((candidate) => ({
            ...candidate,
            status: candidate.status || 'Nouveau', // Si le candidat n'a pas de statut, attribuer "Nouveau"
          }))

          setCandidates(updatedCandidates)
          setShowCandidats(annonceId)
        }
      })
      .catch((e) => console.log(e))
  }

  const showCv = (candidate) => {
    const candidateId = candidate._id
    setIsLoading(true)
    axios
      .get(`cv/${candidateId}`)
      .then((res) => {
        console.log(res)
        setCvData(res.data.data)
        setSelectedUser(candidate)
        setIsModalCV(true)
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleDownloadPdf = () => {
    // Generate a temporary anchor element and set the PDF file as its href
    const link = document.createElement('a')
    link.href = `data:application/pdf;base64,${cvData}`
    link.download = `${selectedUser.firstname}-${selectedUser.lastname}.pdf`

    // Simulate a click event to trigger the download
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleDocumentLoadSuccess = ({ numPages }) => {
    const newArray = Array.from({ length: numPages }, (_, index) => index + 1)
    setNumPages(newArray)
  }

  const [countByStatus, setCountByStatus] = useState({
    Tous: 0,
    Présélection: 0,
    Nouveau: 0,
    'En attente': 0,
    Sélectionné: 0,
    'Entretien tel': 0,
    'RDV Agence': 0,
    'Proposés Client': 0,
    'RDV avec Client': 0,
    Recruté: 0,
    Refusé: 0,
  })

  const handleStatutChange = (candidateId, newStatut) => {
    const newCandidates = selectedAnnonce.candidats.map((candidate) => {
      console.log(candidate._id === candidateId)
      return candidate._id === candidateId
        ? { ...candidate, status: newStatut, candidateId: candidate._id }
        : { ...candidate, candidateId: candidate._id }
    })
    setSelectedAnnonce({ ...selectedAnnonce, candidats: newCandidates })
    axios
      .patch(`annonces/${selectedAnnonce._id}`, { candidats: newCandidates })
      .then((res) => {
        const newAnnonces = [...annonces]
        const annonceIdx = newAnnonces.findIndex(
          (annonce) => annonce._id === selectedAnnonce._id,
        )
        const newAnnonce = res.data
        console.log(newAnnonce)
        const updatedCandidats = newAnnonce.candidats.map((candidat) => ({
          ...candidat.candidateId,
          status: candidat.status || 'Nouveau',
          date: candidat.date,
        }))
        const statuts = [
          'Présélection',
          'Nouveau',
          'En attente',
          'Sélectionné',
          'Entretien tel',
          'RDV Agence',
          'Proposés Client',
          'RDV avec Client',
          'Recruté',
          'Refusé',
        ]
        const countByStatus = newAnnonce.candidats.reduce((acc, candidat) => {
          const statut = candidat.status
          if (statuts.includes(statut)) {
            acc[statut] = (acc[statut] || 0) + 1
          }
          return acc
        }, {})

        const finalCount = {
          Tous: newAnnonce.candidats.length,
          ...Object.fromEntries(statuts.map((s) => [s, countByStatus[s] || 0])),
        }

        setCountByStatus(finalCount)
        const newCandidatsFiltres = updatedCandidats.filter(
          (candidate) => candidate.status === status,
        )
        if (status === 'Tous') {
          setCandidatsFiltres(updatedCandidats)
        } else setCandidatsFiltres(newCandidatsFiltres)
        newAnnonces[annonceIdx] = { ...newAnnonce, candidats: updatedCandidats }
        setAnnonces(newAnnonces)
      })
      .catch((e) => {
        console.log(e)
        message.error("une erreur s'est produite")
      })
  }

  const getInitials = (prenom, nom) => {
    const firstInitial = prenom ? prenom.charAt(0).toUpperCase() : ''
    const lastInitial = nom ? nom.charAt(0).toUpperCase() : ''
    return `${firstInitial}${lastInitial}`
  }

  const handleSearch = () => {
    const filtered = annonces.filter(
      (annonce) =>
        annonce.title &&
        annonce.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
        annonce.town &&
        annonce.town.toLowerCase().includes(searchLocation.toLowerCase()),
    )
    setFilteredAnnonces(filtered)
    setCurrentPage(1)
  }

  const resetFilters = () => {
    setSearchTerm('')
    setSearchLocation('')
    setFilteredAnnonces(annonces)
    setCurrentPage(1)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  const selectAnnonce = (annonce) => {
    const statuts = [
      'Présélection',
      'Nouveau',
      'En attente',
      'Sélectionné',
      'Entretien tel',
      'RDV Agence',
      'Proposés Client',
      'RDV avec Client',
      'Recruté',
      'Refusé',
    ]

    const countByStatus = annonce.candidats.reduce((acc, candidat) => {
      const statut = candidat.status
      if (statuts.includes(statut)) {
        acc[statut] = (acc[statut] || 0) + 1
      }
      return acc
    }, {})

    const finalCount = {
      Tous: annonce.candidats.length,
      ...Object.fromEntries(statuts.map((s) => [s, countByStatus[s] || 0])),
    }

    setCountByStatus(finalCount)
    setCandidatsFiltres(annonce.candidats)
    setSelectedAnnonce(annonce)
    loadCandidats(annonce._id)
    setIsCandidateModalOpen(true)
  }

  const filtrerCandidats = (statut) => {
    setStatus(statut)

    if (statut === 'Tous') {
      setCandidatsFiltres(selectedAnnonce.candidats)
      return
    }

    const newCandidats = selectedAnnonce.candidats.filter(
      (candidate) => candidate.status === statut,
    )
    setCandidatsFiltres(newCandidats)
  }

  const diffuserAnnonce = async (annonce) => {
    try {
      const { data: updatedAnnonce } = await axios.post(
        `annonces/activate/${annonce._id}`,
        { status: !annonce.isActive },
      )

      setAnnonces((prev) =>
        prev.map((a) => (a._id === updatedAnnonce._id ? updatedAnnonce : a)),
      )
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'annonce :", error)
    }
  }

  const createAnnonce = (e) => {
    e.preventDefault()

    const formData = new FormData(e.target) // e.target est le <form>

    const values = Object.fromEntries(formData.entries())

    console.log(values) // un objet avec les noms des inputs comme clés et leurs valeurs

    axios
      .post('annonces', { ...values, client: selectedClient._id })
      .then((res) => {
        console.log(res.data)
        const newAnnonces = [...annonces]
        newAnnonces.unshift(res.data)
        setAnnonces(newAnnonces)
      })
      .catch((e) => console.log(e))
  }
  const archiverAnnonce = (id) => {
    setAnnonces((prev) =>
      prev.map((annonce) =>
        annonce.id === id ? { ...annonce, archivee: true } : annonce,
      ),
    )
  }

  const desArchiverAnnonce = (id) => {
    setAnnonces((prev) =>
      prev.map((annonce) =>
        annonce.id === id ? { ...annonce, archivee: false } : annonce,
      ),
    )
  }

  const annoncesFiltrees = annonces.filter(
    (annonce) =>
      (activeTab === 'actives' && !annonce.archivee) ||
      (activeTab === 'archivees' && annonce.archivee),
  )

  const totalAnnoncesActives = annonces.filter(
    (annonce) => !annonce.archivee,
  ).length

  const openModal = () => {
    setIsOpenModal(true)
  }

  const closeModal = () => {
    setIsOpenModal(false)
  }
  const openCandidateModal = () => {
    setIsCandidateModalOpen(true)
  }
  const closeCandidateModal = () => {
    setIsCandidateModalOpen(false)
  }

  useEffect(() => {
    loadAnnonces()
  }, [])

  const getPaginatedAnnonces = () => {
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    return filteredAnnonces.slice(startIndex, endIndex)
  }

  return (
    <main className="container mx-auto py-8 px-6 bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 min-h-screen">
      {/* En-tête moderne */}
      <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-200">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-2">
              Gestion des annonces d'emploi
            </h1>
            <p className="text-gray-600 text-lg">Créez, gérez et diffusez vos offres d'emploi</p>
          </div>
          <div className="hidden md:flex items-center space-x-4">
            <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-4 rounded-xl">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m-8 0V6a2 2 0 00-2 2v6" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <Tabs
        defaultValue="actives"
        onValueChange={setActiveTab}
        className="w-full"
      >
        {/* Barre de navigation et filtres */}
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 border border-gray-200">
          {/* Onglets */}
          <div className="flex justify-center mb-6">
            <TabsList className="bg-gradient-to-r from-gray-100 to-gray-200 border border-gray-300 rounded-xl shadow-sm p-1">
              <TabsTrigger
                value="actives"
                className="px-6 py-3 text-sm font-semibold rounded-lg transition-all duration-300 data-[state=active]:bg-white data-[state=active]:shadow-md data-[state=active]:text-blue-600"
              >
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-green-500"></div>
                  Annonces actives
                </div>
              </TabsTrigger>
              <TabsTrigger
                value="archivees"
                className="px-6 py-3 text-sm font-semibold rounded-lg transition-all duration-300 data-[state=active]:bg-white data-[state=active]:shadow-md data-[state=active]:text-blue-600"
              >
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-gray-500"></div>
                  Annonces archivées
                </div>
              </TabsTrigger>
            </TabsList>
          </div>

          {/* Formulaire de recherche et boutons */}
          <div className="flex flex-col lg:flex-row gap-6 items-end">
            {/* Champs de recherche */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 flex-1">
              <div>
                <label
                  htmlFor="keyword"
                  className="block text-sm font-semibold text-gray-700 mb-2"
                >
                  Mot-clé ou titre
                </label>
                <div className="relative">
                  <Input
                    id="keyword"
                    type="text"
                    placeholder="Rechercher un poste..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={handleKeyDown}
                    className="pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300"
                  />
                  <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m-8 0V6a2 2 0 00-2 2v6" />
                    </svg>
                  </div>
                </div>
              </div>
              <div>
                <label
                  htmlFor="location"
                  className="block text-sm font-semibold text-gray-700 mb-2"
                >
                  Lieu
                </label>
                <div className="relative">
                  <Input
                    id="searchLocation"
                    type="text"
                    placeholder="Ville ou région..."
                    value={searchLocation}
                    onChange={(e) => setSearchLocation(e.target.value)}
                    onKeyDown={handleKeyDown}
                    className="pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300"
                  />
                  <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {/* Boutons d'action */}
            <div className="flex gap-3">
              <Button
                className="bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300 px-4 py-3 rounded-xl font-medium transition-all duration-300 hover:scale-105"
                onClick={resetFilters}
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Reset
              </Button>

              <Button
                className="bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-800 hover:to-gray-900 text-white px-4 py-3 rounded-xl font-medium transition-all duration-300 hover:scale-105 shadow-lg"
                onClick={handleSearch}
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                Rechercher
              </Button>

              <Button
                className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-4 py-3 rounded-xl font-medium transition-all duration-300 hover:scale-105 shadow-lg"
                onClick={openModal}
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Créer une annonce
              </Button>
            </div>
          </div>
        </div>

        {/* Modal de création d'annonce modernisée */}
        {isOpenModal && (
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9999] overflow-y-auto">
            <div className="bg-white rounded-3xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden relative animate-fade-in-scale">
              {/* En-tête de la modal */}
              <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-6 relative">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="bg-white/20 p-3 rounded-xl">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                    </div>
                    <div>
                      <h2 className="text-3xl font-bold text-white">
                        Créer une nouvelle annonce
                      </h2>
                      <p className="text-blue-100 mt-1">Remplissez les informations ci-dessous</p>
                    </div>
                  </div>
                  <button
                    onClick={closeModal}
                    className="bg-white/20 hover:bg-white/30 p-3 rounded-xl transition-all duration-300 hover:scale-110"
                  >
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Contenu de la modal */}
              <div className="p-8 overflow-y-auto max-h-[calc(90vh-120px)]">

                <form onSubmit={createAnnonce} className="space-y-8">
                  {/* Section Client */}
                  <div className="bg-gradient-to-r from-gray-50 to-blue-50 p-6 rounded-2xl border border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                      <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                      Informations Client
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div ref={clientRef} className="space-y-3">
                        <Label
                          htmlFor="client"
                          className="text-sm font-semibold text-gray-700"
                        >
                          Client(s) concerné(s) *
                        </Label>
                        <div className="relative">
                          <Input
                            value={clientSearch}
                            onChange={(e) => searchClient(e.target.value)}
                            placeholder="Rechercher le client..."
                            className="w-full border-2 border-gray-200 rounded-xl pl-12 pr-4 py-3 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition-all duration-300"
                          />
                          <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                          </div>
                          {isLoadingClient && (
                            <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                              <svg
                                className="animate-spin h-5 w-5 text-blue-500"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8v8H4z"
                                ></path>
                              </svg>
                            </div>
                          )}
                        </div>

                    {showClientDropdown && clients.length > 0 && (
                      <ul className="absolute z-10 mt-1 w-11/12 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto">
                        {clients.map((client) => (
                          <li
                            key={client._id}
                            onClick={() => {
                              setSelectedClient(client)
                              const contacts = client.contacts.map(
                                (contact) =>
                                  `${contact.firstname || ''} ${
                                    contact.lastname || ''
                                  } ${contact.phone || ''} ${
                                    contact.email || ''
                                  }`,
                              )
                              setClientContacts(contacts)
                              console.log(selectedClient)
                              setShowClientDropdown(false)
                            }}
                            className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                              selectedClient?._id === client._id
                                ? 'bg-indigo-100 font-semibold'
                                : ''
                            }`}
                          >
                            {client.companyName}
                          </li>
                        ))}
                      </ul>
                    )}
                    {selectedClient && (
                      <div className="flex flex-wrap gap-2 mt-2">
                        <span className="flex items-center bg-indigo-100 text-indigo-800 text-sm font-medium px-3 py-1 rounded-full">
                          {selectedClient.companyName}
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedClient(null)
                              setClientContacts([])
                            }}
                            className="ml-2 text-indigo-500 hover:text-indigo-700 focus:outline-none"
                          >
                            &times;
                          </button>
                        </span>
                      </div>
                    )}
                  </div>
                  {clientContacts.length > 0 && (
                    <div className="space-y-2">
                      <Label htmlFor="contact">Contact </Label>
                      <Select name="contact">
                        <SelectTrigger id="contact">
                          <SelectValue placeholder="Sélectionnez un contact" />
                        </SelectTrigger>
                        <SelectContent className="bg-white">
                          {clientContacts.map((contact) => {
                            return (
                              <SelectItem value={contact}>{contact}</SelectItem>
                            )
                          })}
                        </SelectContent>
                      </Select>
                    </div>
                  )}
                    </div>
                  </div>

                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                  <div className="space-y-2">
                    <Label htmlFor="email">Email</Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="email@email.com"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="phone">Téléphone</Label>
                    <Input
                      id="phone"
                      name="phone"
                      type="tel"
                      placeholder="06 12 34 56 78"
                    />
                  </div>
                </div> */}

                <div className="space-y-2 mb-4">
                  <Label htmlFor="titre">Intitulé du poste</Label>
                  <Input
                    id="title"
                    name="title"
                    placeholder="Ex: Développeur React Senior"
                    required
                  />
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="localisation">
                    Localisation(voir liste dans le chat)
                  </Label>
                  <Input
                    id="localisation"
                    name="localisation"
                    placeholder="Ex: Paris, France ou Télétravail"
                  />
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="description">Description du poste</Label>
                  <Textarea
                    id="description"
                    name="description"
                    placeholder="Décrivez le poste, les missions, le profil recherché..."
                    rows={5}
                  />
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="profilRecherche">Profil recherché</Label>
                  <Textarea
                    id="profprofilRechercheil"
                    name="profilRecherche"
                    placeholder="Ex: React, gestion de projet, anglais courant"
                    rows={3}
                  />
                </div>
                <div className="space-y-2 mb-4">
                  <Label htmlFor="niveauQualification">
                    Niveau de qualifications
                  </Label>
                  <Select name="niveauQualification">
                    <SelectTrigger id="niveauQualification">
                      <SelectValue placeholder="Sélectionnez un niveau de qualification " />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="Sans dipome">Sans diplôme</SelectItem>
                      <SelectItem value="BEP/CAP">BEP/CAP</SelectItem>
                      <SelectItem value="Employé/Opérateur/Ouvrier/Bac">
                        Employé/Opérateur/Ouvrier/Bac
                      </SelectItem>
                      <SelectItem value="Technicien/Employé/Bac+2">
                        Technicien/Employé/Bac+2
                      </SelectItem>
                      <SelectItem value="Agent de maitrise/Bac+3/Cadre">
                        Agent de maitrise/Bac+3/Cadre
                      </SelectItem>
                      <SelectItem value="Ingénieur/Cadre/Bac+5">
                        Ingénieur/Cadre/Bac+5
                      </SelectItem>
                      <SelectItem value="Cadre dirigeant">
                        Cadre dirigeant
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2 mb-4">
                  <Label htmlFor="experience">Expérience demandée</Label>
                  <Select name="experience">
                    <SelectTrigger id="experience">
                      <SelectValue placeholder="Sélectionnez un niveau d'expérience " />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="Moins d'1 an">Moins d'1 an</SelectItem>
                      <SelectItem value="1 à 7 ans">1 à 7 ans</SelectItem>
                      <SelectItem value="Plus de 7 ans">
                        Plus de 7 ans
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="jobType">Type de contrat</Label>
                  <Select name="jobType">
                    <SelectTrigger id="jobType">
                      <SelectValue placeholder="Sélectionnez un type de contrat" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="CDI">CDI</SelectItem>
                      <SelectItem value="CDD">CDD</SelectItem>
                      <SelectItem value="Intérim">Intérim</SelectItem>
                      <SelectItem value="Stage">Stage</SelectItem>
                      <SelectItem value="Apprentissage">
                        Apprentissage
                      </SelectItem>
                      <SelectItem value="Freelance">Freelance</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="salaire">Fourchette de salaire</Label>
                  <Input
                    id="salaire"
                    name="salaire"
                    placeholder="Ex: 45k€ - 55k€"
                  />
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="baseSalary">Base salaire</Label>
                  <Select name="baseSalary">
                    <SelectTrigger id="baseSalary">
                      <SelectValue placeholder="Sélectionnez une base" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="Heure">Heure</SelectItem>
                      <SelectItem value="Jour">Jour </SelectItem>
                      <SelectItem value="Semaine">Semaine</SelectItem>
                      <SelectItem value="Mois">Mois</SelectItem>
                      <SelectItem value="An">An</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="dateDebutSouhaitee">
                    Date de début souhaitée
                  </Label>
                  <Input
                    id="dateDebutSouhaitee"
                    name="dateDebutSouhaitee"
                    placeholder="Ex: ASAP, JJ/MM/AAAA"
                  />
                </div>
                <div className="space-y-2 mb-4">
                  <Label htmlFor="deplacement">Déplacement</Label>
                  <Select name="deplacement">
                    <SelectTrigger id="deplacement">
                      <SelectValue placeholder="Déplacement" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="Pas de déplacement">
                        Pas de déplacement
                      </SelectItem>
                      <SelectItem value="Départemental">
                        Départemental
                      </SelectItem>
                      <SelectItem value="Régional">Régional</SelectItem>
                      <SelectItem value="National">National</SelectItem>
                      <SelectItem value="International">
                        International
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2 mb-4">
                  <Label htmlFor="tempTravail">Temps de travail</Label>
                  <Select name="tempTravail">
                    <SelectTrigger id="tempTravail">
                      <SelectValue placeholder="Temps de travail" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="Temps complet">
                        Temps complet
                      </SelectItem>
                      <SelectItem value="Temps partiel">
                        Temps partiel
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="presence">Télétravail</Label>
                  <Select name="presence">
                    <SelectTrigger id="presence">
                      <SelectValue placeholder="Télétravail" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="Pas de télétravail">
                        Pas de télétravail
                      </SelectItem>
                      <SelectItem value="Occasionnel">Occasionnel</SelectItem>
                      <SelectItem value="Partiel">Partiel</SelectItem>
                      <SelectItem value="Total (100%)">Total (100%)</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="informationsComplementaires">
                    Informations Complémentaires
                  </Label>
                  <Textarea
                    id="informationsComplementaires"
                    name="informationsComplementaires"
                    placeholder="Informations Complémentaires"
                    rows={3}
                  />
                </div>

                <div className="mt-6 flex justify-end">
                  <Button
                    type="submit"
                    className="bg-red-600 text-white flex-justify-center"
                  >
                    Générer l'annonce
                  </Button>
                </div>
                </form>
              </div>
            </div>
          </div>
        )}
        {isLoading && (
          <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-500 bg-opacity-50 z-[9999]">
            <img
              src={logo2}
              alt="Chargement..."
              className="w-20 h-20 animate-spin duration-1015"
            />
          </div>
        )}
        {isModalCV && (
          <div className="flex items-stretch absolute top-0 min-h-screen  left-0 right-0 z-30 ">
            <div className="grow flex flex-col  items-center justify-center py-6 bg-black bg-opacity-70 min-h-screen">
              <div className="flex items-center my-3 justify-center space-x-4">
                <p
                  className="cursor-pointer bg-white px-2 py-1 text-black rounded-md border border-black"
                  onClick={handleDownloadPdf}
                >
                  Telechargez le cv
                </p>
                <p
                  className="cursor-pointer bg-white px-2 py-1 text-black rounded-md border border-black"
                  onClick={() => setIsModalCV(false)}
                >
                  Fermer
                </p>
              </div>
              <Document
                file={`data:application/pdf;base64,${cvData}`}
                onLoadSuccess={handleDocumentLoadSuccess}
              >
                {numPages.map((x, idx) => {
                  return <Page scale={5 / 3} key={idx} pageNumber={idx + 1} />
                })}
              </Document>
            </div>
          </div>
        )}
        {selectedAnnonce && (
          <Dialog
            open={isCandidateModalOpen}
            onOpenChange={(open) => setIsCandidateModalOpen(open)}
            key={selectedAnnonce?._id}
          >
            <DialogContent className="max-w-8xl h-[90vh] flex flex-col p-0 bg-white shadow-lg rounded-lg">
              <DialogHeader className="p-6 pb-4 border-b bg-gray-100 rounded-t-lg">
                <DialogTitle className="text-2xl font-semibold text-gray-900">
                  Gestion des candidatures
                </DialogTitle>
                <DialogDescription className="text-sm text-gray-600">
                  Pour l'annonce :{' '}
                  <span className="font-medium text-blue-600">
                    {selectedAnnonce ? selectedAnnonce.title : 'Chargement...'}{' '}
                  </span>
                </DialogDescription>
              </DialogHeader>

              <div className="flex-grow overflow-y-auto p-6 pt-0">
                <Tabs
                  value={activeFilterTab}
                  onValueChange={(value) => setActiveFilterTab(value)}
                  className="sticky top-0 bg-white z-10 pt-4 pb-2 mb-4 border-b"
                >
                  <TabsList className="grid w-full grid-cols-12 h-auto gap-5">
                    <TabsTrigger
                      value="Tous"
                      onClick={() => filtrerCandidats('Tous')}
                      className="text-xs px-3 py-1.5 h-auto data-[state=active]:bg-indigo-100 data-[state=active]:text-indigo-700"
                    >
                      Tous ({countByStatus['Tous'] || 0})
                    </TabsTrigger>
                    {statutOptions.map((statut) => (
                      <TabsTrigger
                        key={statut}
                        onClick={() => filtrerCandidats(statut)}
                        value={statut}
                        className="text-xs px-3 py-1.5 h-auto data-[state=active]:bg-indigo-100 data-[state=active]:text-indigo-700 whitespace-nowrap"
                      >
                        {statut} ({countByStatus[statut] || 0})
                      </TabsTrigger>
                    ))}
                  </TabsList>
                </Tabs>

                {candidatsFiltres === 0 ? (
                  <div className="flex flex-col items-center justify-center h-full text-gray-500">
                    <Briefcase size={48} className="mb-4" />
                    <p className="text-xl font-medium">
                      Aucune candidature pour cette annonce.
                    </p>
                    <p>
                      Revenez plus tard ou partagez l'annonce pour recevoir des
                      candidatures.
                    </p>
                  </div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead className="w-[250px]">Candidat</TableHead>
                        <TableHead>Contact</TableHead>
                        <TableHead className="w-[180px]">Statut</TableHead>
                        <TableHead>Infos Clés</TableHead>
                        <TableHead className="text-right">Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {candidatsFiltres.map((candidate, idx) => (
                        <TableRow key={idx} className="hover:bg-gray-50">
                          <TableCell>
                            <div className="flex items-center space-x-3">
                              <Avatar className="h-10 w-10 border">
                                <AvatarImage
                                  src={candidate.email}
                                  alt={`${candidate.lastName}`}
                                />
                                <AvatarFallback className="bg-gray-200 text-gray-600">
                                  {getInitials(candidate.firstname)}{' '}
                                  {getInitials(candidate.lastname)}
                                </AvatarFallback>
                              </Avatar>
                              <div>
                                <div className="font-medium">
                                  <span className="capitalize">
                                    {candidate.firstname}{' '}
                                  </span>
                                  <span className="uppercase">
                                    {candidate.lastname}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex flex-col space-y-1">
                              <a
                                href={`mailto:${candidate.email}`}
                                className="text-xs text-blue-600 hover:underline flex items-center"
                              >
                                <Mail size={14} className="mr-1.5" />{' '}
                                {candidate.email}
                              </a>
                              {candidate.phone && (
                                <span className="text-xs text-gray-600 flex items-center">
                                  <Phone size={14} className="mr-1.5" />{' '}
                                  {candidate.phone}
                                </span>
                              )}
                            </div>
                          </TableCell>
                          <TableCell>
                            <Select
                              onValueChange={(e) =>
                                handleStatutChange(candidate._id, e)
                              }
                              value={candidate.status}
                            >
                              <SelectTrigger
                                className={`h-8 text-xs ${
                                  statutColors[candidate.status] ||
                                  'bg-gray-100 text-gray-800'
                                } border-none font-medium`}
                              >
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent>
                                {statutOptions.map((statut) => (
                                  <SelectItem
                                    key={statut}
                                    value={statut}
                                    className={`text-xs ${
                                      statutColors[statut] ||
                                      'bg-gray-100 text-gray-800'
                                    }`}
                                  >
                                    {statut}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </TableCell>
                          <TableCell className="text-xs">
                            <div className="flex items-center text-gray-600 mb-0.5">
                              <CalendarDays
                                size={14}
                                className="mr-1.5 text-gray-400"
                              />{' '}
                              Candidature le : {formatJsDate(candidate.date)}
                            </div>
                            {candidate.experience && (
                              <div className="flex items-center text-gray-600 mb-0.5">
                                <Briefcase
                                  size={14}
                                  className="mr-1.5 text-gray-400"
                                />{' '}
                                Exp: {candidate.experience}
                              </div>
                            )}
                            {candidate.pretentionsSalariales && (
                              <div className="flex items-center text-gray-600">
                                <Euro
                                  size={14}
                                  className="mr-1.5 text-gray-400"
                                />{' '}
                                {candidate.pretentionsSalariales}
                              </div>
                            )}
                          </TableCell>
                          <TableCell className="text-right">
                            {candidate && (
                              <Button
                                variant="outline"
                                size="sm"
                                asChild
                                className="mr-2 h-8 px-2"
                                onClick={() => showCv(candidate)}
                              >
                                <a>
                                  <FileText size={14} className="mr-1" /> CV
                                </a>
                              </Button>
                            )}
                            <Button
                              variant="outline"
                              size="sm"
                              className="h-8 px-2"
                              onClick={() =>
                                (window.location.href = `mailto:${candidate.candidate.email}?subject=Réponse à votre candidature pour ${selectedAnnonce.title}`)
                              }
                            >
                              <Mail size={14} className="mr-1" /> Contacter
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </div>

              <DialogFooter className="p-6 pt-4 border-t">
                <Button variant="outline" onClick={closeCandidateModal}>
                  Fermer
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        )}

        <TabsContent value="actives" className="mt-0">
          {/* Statistiques des annonces */}
          <div className="mb-8 bg-gradient-to-r from-white to-blue-50 p-8 rounded-2xl shadow-lg border border-blue-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-4 rounded-xl mr-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 flex items-center">
                    <span className="text-4xl font-extrabold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mr-3">
                      {totalAnnoncesActives}
                    </span>
                    annonces en cours de diffusion
                  </h2>
                  <p className="text-gray-600 mt-1">Visibles sur l'application mobile</p>
                </div>
              </div>
              <div className="hidden md:flex items-center space-x-4">
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600">Active</div>
                  <div className="w-3 h-3 bg-green-500 rounded-full mx-auto animate-pulse"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            {annonces.map((annonce) => (
              <Card
                key={annonce._id}
                className="w-full overflow-hidden border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.02] bg-gradient-to-r from-white to-gray-50 border-l-4 border-l-blue-500"
              >
                <CardContent className="p-0">
                  <div className="p-8 border-b border-gray-100">
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        <div className="flex items-start gap-4">
                          <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-3 rounded-xl">
                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m-8 0V6a2 2 0 00-2 2v6" />
                            </svg>
                          </div>
                          <div className="flex-1">
                            <h3 className="text-2xl font-bold text-gray-800 mb-2">
                              {annonce.title}
                            </h3>
                            <div className="flex items-center gap-2 mb-4">
                              <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                              </svg>
                              <p className="text-gray-600 font-medium">
                                {annonce.localisation}
                              </p>
                            </div>
                            <Badge
                              variant="outline"
                              className="bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700 hover:from-blue-100 hover:to-indigo-100 border-blue-200 px-6 py-2 text-sm font-semibold rounded-full cursor-pointer transition-all duration-300 hover:scale-105"
                              onClick={() => {
                                selectAnnonce(annonce)
                              }}
                            >
                              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                              </svg>
                              {annonce.candidats?.length || 0} candidature(s)
                            </Badge>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col space-y-4">
                        <div className="flex items-center space-x-3">
                          <button className="p-2 bg-blue-100 hover:bg-blue-200 rounded-lg transition-colors duration-300 group">
                            <PencilIcon
                              className="h-5 w-5 text-blue-600 group-hover:scale-110 transition-transform duration-300"
                              title="Modifier l'annonce"
                            />
                          </button>
                          <button className="p-2 bg-green-100 hover:bg-green-200 rounded-lg transition-colors duration-300 group">
                            <EyeIcon
                              className="h-5 w-5 text-green-600 group-hover:scale-110 transition-transform duration-300"
                              title="Voir l'annonce"
                            />
                          </button>
                          <button className="p-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-300 group">
                            <DocumentDuplicateIcon
                              className="h-5 w-5 text-gray-600 group-hover:scale-110 transition-transform duration-300"
                              title="Dupliquer l'annonce"
                            />
                          </button>

                          <Button
                            onClick={() => diffuserAnnonce(annonce)}
                            className={
                              annonce.isActive
                                ? 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-4 py-2 rounded-lg font-medium transition-all duration-300 hover:scale-105 shadow-lg'
                                : 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-4 py-2 rounded-lg font-medium transition-all duration-300 hover:scale-105 shadow-lg'
                            }
                            size="sm"
                          >
                            {annonce.isActive ? (
                              <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                                Diffusée
                              </div>
                            ) : (
                              <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-white rounded-full"></div>
                                Non diffusée
                              </div>
                            )}
                          </Button>
                        </div>

                        <div className="flex items-center space-x-3 justify-end">
                          <Button
                            onClick={() => archiverAnnonce(annonce._id)}
                            variant="outline"
                            size="sm"
                            className="border-gray-300 hover:bg-gray-100 text-gray-700 px-4 py-2 rounded-lg font-medium transition-all duration-300 hover:scale-105"
                          >
                            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8l4 4 4-4m6 0l-1 12a2 2 0 01-2 2H8a2 2 0 01-2-2L5 8m5 3v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            Archiver
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Pipeline de candidatures moderne */}
                  <div className="bg-gradient-to-br from-slate-50 to-blue-50 p-8 rounded-2xl border border-slate-200">
                    <h4 className="text-xl font-bold text-slate-800 mb-6 flex items-center">
                      <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-2 rounded-lg mr-3">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                        </svg>
                      </div>
                      Pipeline de recrutement
                    </h4>

                    {/* Version horizontale avec flèches */}
                    <div className="flex flex-wrap items-center gap-4 justify-center">
                      {[
                        { label: 'Tous', status: '', color: 'slate', count: annonce.candidats.length },
                        { label: 'Nouveau', status: 'Nouveau', color: 'blue' },
                        { label: 'Présélection', status: 'Présélection', color: 'indigo' },
                        { label: 'En attente', status: 'En attente', color: 'purple' },
                        { label: 'Sélectionné', status: 'Sélectionné', color: 'pink' },
                        { label: 'Entretien tel', status: 'Entretien tel', color: 'rose' },
                        { label: 'RDV Agence', status: 'RDV agence', color: 'orange' },
                        { label: 'Proposés Client', status: 'Proposés Client', color: 'amber' },
                        { label: 'RDV Client', status: 'RDV Client', color: 'yellow' },
                        { label: 'Recruté', status: 'Recruté', color: 'green' },
                        { label: 'Refusé', status: 'Refusé', color: 'red' }
                      ].map((item, index) => {
                        const count = item.status === '' ? item.count : annonce.candidats.filter(c => c.status === item.status).length;
                        const isActive = count > 0;

                        return (
                          <div key={index} className="flex items-center">
                            {/* Carte de statut */}
                            <div className={`
                              relative group cursor-pointer transition-all duration-300 transform hover:scale-110
                              ${isActive ? 'hover:shadow-lg' : 'opacity-60'}
                            `}>
                              <div className={`
                                relative overflow-hidden rounded-2xl p-4 min-w-[100px] text-center
                                ${isActive
                                  ? `bg-gradient-to-br from-${item.color}-100 to-${item.color}-200 border-2 border-${item.color}-300 shadow-md`
                                  : 'bg-gray-100 border-2 border-gray-200'
                                }
                              `}>
                                {/* Badge du label */}
                                <div className={`
                                  inline-block px-3 py-1 rounded-full text-xs font-bold mb-2
                                  ${isActive
                                    ? `bg-${item.color}-500 text-white`
                                    : 'bg-gray-400 text-white'
                                  }
                                `}>
                                  {item.label}
                                </div>

                                {/* Compteur */}
                                <div className={`
                                  text-2xl font-extrabold
                                  ${isActive
                                    ? `text-${item.color}-700`
                                    : 'text-gray-500'
                                  }
                                `}>
                                  {count}
                                </div>

                                {/* Effet de brillance pour les actifs */}
                                {isActive && (
                                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                                )}
                              </div>

                              {/* Indicateur d'activité */}
                              {isActive && (
                                <div className={`absolute -top-1 -right-1 w-4 h-4 bg-${item.color}-500 rounded-full animate-pulse`}></div>
                              )}
                            </div>

                            {/* Flèche de progression (sauf pour le dernier) */}
                            {index < 10 && (
                              <div className="mx-2 text-gray-400">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}

            {annoncesFiltrees.length === 0 && (
              <div className="p-12 text-center bg-white rounded-lg border border-gray-200 shadow-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-16 w-16 mx-auto mb-4 text-gray-300"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                <h3 className="text-xl font-medium text-gray-900 mb-2">
                  Aucune annonce active
                </h3>
                <p className="text-gray-500 mb-6">
                  Créez une nouvelle annonce pour commencer le recrutement.
                </p>
                <Button
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 font-medium text-sm rounded-md shadow-sm transition-colors duration-200"
                  onClick={openModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 3a1 1 0 00-1 1v5H4a1 1 0 100 2h5v5a1 1 0 102 0v-5h5a1 1 0 100-2h-5V4a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Créer une annonce
                </Button>
              </div>
            )}
          </div>
        </TabsContent>
      </Tabs>
    </main>
  )
}

export default Annonces
